import { createFileRoute, notFound } from "@tanstack/react-router";

import { AuthView } from "@/components/pages/AuthView";
import { meta } from "@/content/meta";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/login")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/login",
          noIndex: true,
          ...meta[params.locale].login,
        })
      : {},
  component: LoginRoute,
});

function LoginRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return <AuthView locale={locale} mode="login" />;
}

